//importamos elementos propios de React
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
//importamos archivos creados por nosotros y plugins externos instalados
import { setFormSlice } from "../../app/slices/formSlice";
import Slider, { SliderTooltip, Handle } from 'rc-slider';
import AwesomeSlider from "react-awesome-slider";
import Carousel from 'react-multi-carousel';
import anime from "animejs";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Div100vh from 'react-div-100vh';
//https://github.com/atlassian/react-beautiful-dnd
//importamos componentes reutilizables
import Title from "../../components/Title";
import Subtitle from "../../components/Subtitle";
import Card from "../../components/Card";
import CardSelect from "../../components/CardSelect";
import ButtonArrow from "../../components/Buttons/ButtonArrow";
import Contador from "../../components/Contador";
import LayerBox from "../../components/LayerBox";

import Blob1 from "../../components/Blobs/Blob1";
import Blob2 from "../../components/Blobs/Blob2";
import Blob3 from "../../components/Blobs/Blob3";
import Blob4 from "../../components/Blobs/Blob4";
import Blob5 from "../../components/Blobs/Blob5";
import Blob6 from "../../components/Blobs/Blob6";
import Blob7 from "../../components/Blobs/Blob7";
import Blob8 from "../../components/Blobs/Blob8";
import Blob9 from "../../components/Blobs/Blob9";
import Blob10 from "../../components/Blobs/Blob10";
import FormUser from "../FormUser";
import Submitted from "../Submitted";
//importamos archivo de estilos del componente y plugins
import "./Form.scss";
import { Button, CardDeck } from "react-bootstrap";
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

// para poder visualizar las imágenes en WP
const url = "/wp-content/plugins/hmg-react-app/frontend/build/";

function Form() {

    /* FUNCIONES DATOS EN REDUX */

    //variable de redux para utilizar los hooks de redux
    const dispatch = useDispatch();
    const form = useSelector(state => state.casa.form);


    //variables especiales para que tengan un valor por defecto si se deja por defecto
    const [resultCardOrder, setResultCardOrder] = useState('cocina,salon,dormitorio');
    const [resultSelectCard, setResultSelectCard] = useState(null);

    //---------------------------------------//

    /* RANGE SLIDER DORMITORIOS */

    //variable para cambiar la palabra habiación del range slider
    const [numhabitacion, setNumHabitacion] = useState("habitación");
    //variable para setear el valor del range slider de dormitorios
    const [valueSlider, setValueSlider] = useState(1);

    const listNumhab = {
        1: "916580000",
        2: "916580001",
        3: "3",
        4: "916580003",
    }
    //variable código CRM
    const valuesNumHab = Object.values(listNumhab);

    //función para dibujar las imágenes de las camas modificando la opacidad
    function showBeds(): void {
        //variable donde se guarda el array de las imágenes de la cama
        const listadoImgCamas = document.querySelectorAll('.form__content__step__imgCamas__cama');
        //variable para quitarle la opacidad a las imágenes
        const hidden = 'mvc-opacity-cero';
        //bucle para recorrer las etiquetas img del DOM, y ocultarlas según el valor del range slider
        listadoImgCamas.forEach((elem, index) => {
            if (valueSlider === 1) {

                if (index === 0) {
                    elem.classList.remove(hidden);
                } else {
                    elem.classList.add(hidden);
                }
            } else if (valueSlider === 2) {

                if (index === 0 || index === 1) {
                    elem.classList.remove(hidden);
                } else {
                    elem.classList.add(hidden);
                }
            } else if (valueSlider === 3) {

                if (index !== 3) {
                    elem.classList.remove(hidden);
                } else {
                    elem.classList.add(hidden);
                }
            } else if (valueSlider === 4) {

                elem.classList.remove(hidden);
            }
        });
    }

    //función para cambiar el texto del número de habitaciones de singular a plural en el RangeSlider
    function changeNumHab(value) {
        setValueSlider(value);
        if (value === 1) {
            setNumHabitacion("habitación");
        } else {
            setNumHabitacion("habitaciones");
        }
    }

    //---------------------------------------//

    /* SELECTOR RANGO EDAD */

    //variable de rangos de edad
    const listAges = {
        "18-24": "916580005",
        "25-30": "916580000",
        "30-40": "916580001",
        "40-50": "916580002",
        "50-60": "916580003",
        "+60": "916580004"
    }
    const nameAges = Object.keys(listAges);
    const valueAges = Object.values(listAges);

    //variable contador de rango de edad y función de incremento y decremento
    const [countAge, setCountAge] = useState(0);



    //función para incrementar el array de rango de edad
    function incrementAgeList(): void {
        setCountAge(add => add + 1);
        if (countAge === 4) {
            setCountAge(0);
        }
    }

    //función para decrementar el array de rango de edad
    function decrementAgeList(): void {
        setCountAge(less => less - 1);
        if (countAge === 0) {
            setCountAge(4);
        }
    }

    //---------------------------------------//

    /* RANGE SLIDER METROS VIVIENDA */

    //variable con el listados de los valores de los metros de la vivienda
    const listMetros = {
        1: '60',
        2: '60-85',
        3: '85-100',
        4: '100-120',
        5: '+120',
    };

    const listValueMetros = {
        1: '916580000',
        2: '916580005',
        3: '916580001',
        4: '916580006',
        5: '916580002',
    }

    //variable para setear el valor del range slider de metros de la vivienda
    const [valueSliderMetros, setValueSliderMetros] = useState(1);
    //variable para crear la etiqueta con el número de metros
    const { createSliderWithTooltip } = Slider;
    const { Handle } = Slider;

    //variables con los códigos de valor del CRM
    const valuesListMetros = Object.values(listValueMetros);

    //variable para indicar el valor en metros cuadrados dentro del RangeSlider
    const formatMetros = () => {
        anime({
            targets: document.querySelector(".rc-tooltip-content"),
            direction: 'normal',
            translateX: 10,
            duration: 300,
            easing: 'easeInOutQuad'
        })
        return (
            <div className="slider-metros">
                <p className="slider-metros__title"> {listMetros[valueSliderMetros]}</p>
                <p className="slider-metros__metros"> m2</p>
            </div>
        )
    };

    //función para setear el valor del RangeSlider
    function changeMetros(value) {

        //condición para que no pueda ir al paso 0
        if (value === 0) {
            setValueSliderMetros(1);
        } else {
            setValueSliderMetros(value);
        }

        const primerDot = document.querySelectorAll(".rc-slider-dot");
        primerDot[0].classList.add("d-none");
    }

    //función para añadir la etiqueta encima del slider
    const handle = props => {
        const { valueMetros, dragging, index, ...restProps } = props;
        return (
            <SliderTooltip
                overlay={formatMetros}
                visible={true}
                placement="top"
                key={index}
            >
                <Handle value={valueMetros} {...restProps} />
            </SliderTooltip>
        );
    };

    //---------------------------------------//

    /* RANGE SLIDER CUOTA VIVIENDA */

    //variable con el listados de los valores de la cuota de la vivienda
    const listCuota = {
        1: '600-750',
        2: '750-1000',
        3: '1000-1200',
        4: '1200-1500',
        5: '1500-2000',
        6: '+2000',
    };

    const valuesListCuota = {
        1: '916580000',
        2: '916580001',
        3: '916580002',
        4: '916580003',
        5: '916580004',
        6: '916580005',
    }

    //variable códigos CRM
    const valuesCuota = Object.values(valuesListCuota);

    //variable para setear el valor del range slider de cuota de la vivienda
    const [valueSliderCuota, setValueSliderCuota] = useState(1);

    //variable para indicar el valor en euros dentro del RangeSlider
    const formatCuota = () => {
        anime({
            targets: document.querySelector(".rc-tooltip-content"),
            direction: 'normal',
            translateX: 10,
            duration: 300,
            easing: 'easeInOutQuad'
        });

        return (
            <div className="slider-cuota">
                <p className="slider-cuota__title"> {listCuota[valueSliderCuota]}</p>
                <div></div>
                <p className="slider-cuota__cuota">€</p>
            </div>
        )
    };

    //función para añadir la etiqueta encima del slider
    const handleCuota = props => {
        const { valueMetros, dragging, index, ...restProps } = props;
        return (
            <SliderTooltip
                overlay={formatCuota}
                visible={true}
                placement="top"
                key={index}
            >
                <Handle value={valueSliderCuota} {...restProps} />
            </SliderTooltip>
        );
    };

    //función para añadir la etiqueta encima del slider
    const handleCuotaVertical = props => {
        const { valueMetros, dragging, index, ...restProps } = props;
        return (
            <SliderTooltip
                overlay={formatCuota}
                visible={true}
                placement="right"
                key={index}
            >
                <Handle value={valueSliderCuota} {...restProps} />
            </SliderTooltip>
        );
    };

    //función para setear el valor del RangeSlider
    function changeCuota(value) {
        setValueSliderCuota(value);
    }

    //---------------------------------------//

    /* PAGINACIÓN Y CONTADOR DE PREGUNTAS */

    //variable para inicializar la cuenta de los steps y el contador
    const [count, setCount] = useState(1);
    //variable para activar la transición del step 1 y el último
    const [active, setActive] = useState('');

    //función para gestionar la visibilidad de los botones "siguiente" y "anterior"
    //y para gestionar la visibilidad de cards seleccionadas de las preguntas
    function prevFunction() {

        const buttonPrev = document.querySelector(".awssld__prev");
        const buttonNext = document.querySelector(".awssld__next");
        const listCards = document.querySelectorAll(".card");
        let numeroCardSelected;

        if (count === 1) {
            buttonPrev.setAttribute("style", "display: none");
        } else if (count === 17) {
            buttonPrev.setAttribute("style", "visibility: hidden");
            buttonNext.setAttribute("style", "visibility: hidden");
        } else if (count < 5) { //habilita el botón siguiente si vuelves atrás en las 3 primeras preguntas
            buttonNext.classList.remove("disabledNext");
        } else if (count >= 5 && count <= 11) { //bloqueo botón next si no selecciona una card
            buttonNext.classList.add("disabledNext");
            let numeroCardSelected;
            //controla si la card anterior ha sido seleccionada y el dato se ha guardado en redux, y si es así mantiene
            //la respuesta almacenada y la respuesta de la card seleccionada
            for (let i = 0; i < listCards.length; i++) {
                const dataAtributteCard = listCards[i].getAttribute("data-atributo");
                const resultRespuesta = Object.values(form).includes(dataAtributteCard);
                const inputCard = document.querySelector('.inputCard');
                if (resultRespuesta) {
                    listCards[i].classList.add("selectedCard");
                    buttonNext.classList.remove("disabledNext");
                    inputCard.setAttribute("value", dataAtributteCard);

                    numeroCardSelected = listCards[i].parentElement.getAttribute('data-index');
                }
            }

            // como entra varias veces en la función, primero hay que ver que la referencia tenga valor y
            // luego llamar a la función que coloca la card en un slider que se pueda ver.
            if (carouselRef.state !== undefined) {
                moveCardsSelectedPrev(numeroCardSelected);
            }


        } else if (count >= 11 && count <= 12) {
            buttonNext.classList.add("disabledNext");
            //controla si la card anterior ha sido seleccionada y el dato se ha guardado en redux, y si es así mantiene
            //la respuesta almacenada y la respuesta de la card seleccionada
            for (let i = 0; i < listCards.length; i++) {

                const dataAtributteCard = listCards[i].getAttribute("data-atributo");
                const resultRespuesta = Object.values(form).includes(dataAtributteCard);
                const inputCard = document.querySelector('.inputCard');
                if (resultRespuesta) {
                    listCards[i].classList.add("selectedCard");
                    buttonNext.classList.remove("disabledNext");
                    inputCard.setAttribute("value", dataAtributteCard);

                    numeroCardSelected = listCards[i].parentElement.getAttribute('data-index');
                }
            }

            // como entra varias veces en la función, primero hay que ver que la referencia tenga valor y
            // luego llamar a la función que coloca la card en un slider que se pueda ver.
            if (carouselRef.state !== undefined) {
                moveCardsSelectedPrev(numeroCardSelected);
            }

        } else if (count === 12) {
            let x = window.scrollX;
            let y = window.scrollY;
            window.onscroll = function () {
                window.scrollTo(x, y)
            };
        } else if (count === 14) {
            //controla si las 3 cards anteriores han sido seleccionadas y el dato se ha guardado en redux, y si es así mantiene
            //las respuestas almacenadas y las respuestas de la cards seleccionadas
            if (resultSelectCard) {
                const arrayResult = resultSelectCard.split(',');


                for (let i = 0; i < listCards.length; i++) {

                    const valueCards = listCards[i].getAttribute("data-atributo");
                    for (let j = 0; j < arrayResult.length; j++) {
                        const resultCard = arrayResult[j];
                        if (valueCards == resultCard) {
                            listCards[i].classList.add("selectedCard");
                            buttonNext.classList.remove("disabledNext");
                        }
                    }
                }
            }
        } else if (count === 19) {
            buttonPrev.setAttribute("style", "display: none");
        }
    }

    //inicialización de la función
    useEffect(() => {
        prevFunction();
        reportWindowSize();
        // si hay campaña recuperamos el nombre de la URL y lo añadimos como un campo más
        const campana = getUrlCampaign();
        if (campana !== 0) {
            setValueCampana(campana);
        } else {
            setValueCampana('Metrovacesa - Tracking');
        }
    }, [count]);

    const [mobile, setMobile] = useState(false);

    /**
     * Función reportWindowSize.
     * En caso de que haya un resize de la pantalla se toman ciertas acciones en algunos sliders
     */
    function reportWindowSize() {

        // input pregunta 15
        const input15 = document.querySelector('#mvc-pregunta-15');
        // slider del formulario con datos personales
        const nombreUsuario = document.querySelector('#nombre');
        // obtenemos la ID de pregunta del textArea
        const preguntaTextArea = document.querySelector('#pregunta');

        if (window.matchMedia("(max-width: 576px)").matches) {
            /* La pantalla tiene menos de 576 píxeles de ancho */
            // para activar el modo mobile en el slider del rango de precios
            if (input15) {
                setMobile(true);

            } else if (preguntaTextArea) {
                //modifica el contenedor del Text area en mobile
                const textArea = document.querySelector("textarea");
                textArea.setAttribute('rows', '7');
            }

        } else {

            // para desactivar el modo mobile en el slider del rango de precios
            if (input15) {
                setMobile(false);
            } else if (preguntaTextArea) {
                //modifica el contenedor del Text area en mobile
                const textArea = document.querySelector("textarea");
                textArea.setAttribute('rows', '7');
            }
        }

        if (window.matchMedia("(max-height: 740px)").matches) {

            if (nombreUsuario) {
                const awssldContent = document.querySelector(".awssld__content");
                const awssldWrapper = document.querySelector(".awssld__wrapper");
                // const awssldPrev = document.querySelector(".awssld__prev");

                awssldContent.setAttribute('style', 'overflow-y: scroll');
                awssldWrapper.setAttribute('style', 'overflow: initial');
                // awssldPrev.setAttribute('style', 'bottom: -17vh !important');
            }
        }
    }

    // para controlar si hay uin resize en la pantalla
    window.onresize = reportWindowSize;

    //función que guarda valores en redux de los "input hidden"
    function saveDataRedux() {

        if (count < 16) {
            //función para añadir valores de las respuestas a redux
            let value = document.getElementById('mvc-pregunta-' + count).value;
            const name = document.getElementById('mvc-pregunta-' + count).name;

            const [section, fieldname] = name.split('.');

            //condición para guardar valores en redux de 3 preguntas concretas que daban error con la función general
            if (fieldname === 'opcionpersonalizacion_coste') {
                value = resultCardOrder;
            } else if (fieldname === 'top3') {
                value = resultSelectCard;
            }

            var pathArray = window.location.pathname.split('/');
            var zonainteresValue = pathArray[2];

            //creamos la ID del dataLayer
            const data_layer_date = new Date().valueOf();
            const data_layer_str = data_layer_date.toString();
            const value_datalayerid = data_layer_str;

            dispatch(setFormSlice({
                form: {
                    ...form,
                    [fieldname]: value,
                    zonainteres: zonainteresValue,
                    "datalayerid": value_datalayerid
                }
            }));
        } else if (count > 16) {
            saveUrl();
        }
    }

    //variable que setea el valor de datalayerid
    const [value_datalayerid, setValue_datalayerid] = useState('');

    //variable que setea el valor de campaña
    const [valueCampana, setValueCampana] = useState('');

    /**
     * Función getUrlCampaign.
     * Devuelve el nombre de la campaña que aparece como parámetro en la URL, false en caso de que no haya
     * @returns {number, string}
     */

    function getUrlCampaign() {
        let hash;
        let campaign = 0;
        const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            if (hash[0] === 'utm_campaign') {
                const campaign = hash[1];
            }
        }
        return campaign;
    }

    //función para añadir la url actual a redux
    function saveUrl() {

        const pathArray = window.location.pathname.split('/');
        const value = pathArray[2];

        // si hay campaña recuperamos el nombre de la URL y lo añadimos como un campo más
        const campana = getUrlCampaign();

        //creamos la ID del dataLayer
        const data_layer_date = new Date().valueOf();
        const data_layer_str = data_layer_date.toString();
        const value_datalayerid = data_layer_str;

        dispatch(setFormSlice({
            form: {
                ...form,
                zonainteres: value,
                "datalayerid": value_datalayerid,
                "campana_fb": valueCampana
            }
        }));
    }

    //función del contador de los steps y recogida de datos del formulario en redux
    function index_slider(e) {

        const currentPage = e.currentIndex;
        const buttonNext = document.querySelector(".awssld__next");
        const buttonPrev = document.querySelector(".awssld__prev");
        const contador = document.querySelector(".form__contador");

        //condición para setear el contador en 1 y activar el botón anterior a partir del slider 1
        if (currentPage === 0) {
            setCount(1);
            setActive('');
        } else if (currentPage > 0) {
            setCount(currentPage + 1);
            // setActive('active');
            buttonPrev.setAttribute("style", "display: flex");
        }

        //condición para activar y desactivar los botones del slider y el contador dependiendo de la página
        if (currentPage <= 17) {
            if (currentPage === 10) {

                buttonNext.classList.remove("disabledNext");

            } else if (currentPage === 13) {

                buttonNext.classList.add("disabledNext");

            } else if (currentPage === 16) {

                contador.setAttribute("style", "display: flex");
                buttonNext.setAttribute("style", "visibility: show");

            } else if (currentPage === 17) {

                contador.setAttribute("style", "display: none");
                buttonNext.setAttribute("style", "visibility: show");

            } else if (currentPage === 18) {

                contador.setAttribute("style", "visibility: hidden");
                buttonNext.setAttribute("style", "display: none");
                buttonPrev.setAttribute("style", "display: none");
            }
        }
    }

    // Función para el comienzo de la transición del carrusel
    function transition_start_slider(ev) {

        // Animación de flechas
        anime_arrow_slider_start();
        // Animación de blobs
        transition_blob_start(ev);
        // añadir los blobs según el número de pregunta en el que se esté
        add_blobs_dynamic(ev);
        //guardar valores en redux
        saveDataRedux();
    }

    // Animación flechas slider al INICIO de la transición
    function anime_arrow_slider_start() {
        anime({
            targets: document.querySelector("#next-awesome"),
            direction: 'alternate',
            translateX: 50,
            duration: 300,
            easing: 'easeInOutQuad'
        });
        anime({
            targets: document.querySelector("#prev-awesome"),
            direction: 'alternate',
            translateX: -50,
            duration: 300,
            easing: 'easeInOutQuad'
        });

    }

    // Función para la animación de blobs (Inicio de la transición)
    function transition_blob_start(ev) {

        const currentIndex = ev.currentIndex;
        const nextIndex = ev.nextIndex;

        if (currentIndex < nextIndex) {

            const left = nextIndex * -100;
            anime({
                targets: document.querySelector('.container-blob'),
                left: left + 'vw',
                duration: 10000,
                elasticity: 500,
                easing: "easeOutElastic(1, 0.6)",
                endDelay: 2000,
            });


        } else if (currentIndex > nextIndex) {

            const left = nextIndex * -100;
            anime({
                targets: document.querySelector('.container-blob'),
                left: left + 'vw',
                duration: 10000,
                elasticity: 500,
                easing: "easeOutElastic(1, 0.6)",
                endDelay: 2000,
            });
        } else {
            console.log('error en animación');
        }
    }

    //variable contador de rango de edad y función de incremento y decremento
    const [blobActivoImpar, setBlobActivoImpar] = useState(<Blob1 />);
    const [blobActivoPar, setBlobActivoPar] = useState(<Blob2 />);


    // Añadimos los blobs según la pregunta en la que estemos para que como máximo solo haya cargadas
    // dos animaciones a la vez y no se sobrecargue la página
    //controla el color de las flechas del slider
    function add_blobs_dynamic(ev) {

        const currentIndex = ev.currentIndex;

        const nextIndex = ev.nextIndex;

        const arrowNextWhite = document.querySelector(".icono-arrow-next-white");
        const arrowPrevWhite = document.querySelector(".icono-arrow-prev-white");
        const arrowNextBlue = document.querySelector(".icono-arrow-next-blue");
        const arrowPrevBlue = document.querySelector(".icono-arrow-prev-blue");
        const textNext = document.querySelector(".button-awesome-custom-next");
        const textPrev = document.querySelector(".button-awesome-custom-prev");

        const tooltip = document.querySelector(".rc-tooltip-inner");
        const tooltipCuota = document.querySelector(".rc-tooltip-inner");

        const logo_mvc = document.querySelector("#logo-metrovacesa path");
        if (currentIndex === 0 && nextIndex === 1) {

            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            textPrev.setAttribute("style", "color: #1E48BC");

            anime({
                targets: document.querySelector('.layerBox'),
                width: '105%',
                duration: 100,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso1_Edad_' + nameAges[countAge]
            });
            const valuePodrias = document.querySelector('#mvc-pregunta-1').value;



            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso0_Motivo_' + valuePodrias
            });


        } else if (currentIndex === 1 && nextIndex === 0) {

            setBlobActivoImpar(<Blob1 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");

            anime({
                targets: document.querySelector('.layerBox'),
                width: '85%',
                duration: 100,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso1_Edad_' + nameAges[countAge]
            });


        } else if (currentIndex === 1 && nextIndex === 2) {

            setBlobActivoImpar(<Blob1 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");

            anime({
                targets: tooltip,
                opacity: [0, 1],
                duration: 1000,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso2_Habitaciones_' + valueSlider
            });


        } else if (currentIndex === 2 && nextIndex === 1) {

            setBlobActivoImpar(<Blob1 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");

            tooltip.classList.add("d-none");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso2_Habitaciones_' + valueSlider
            });

        } else if (currentIndex === 2 && nextIndex === 3) {

            setBlobActivoImpar(<Blob3 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");



            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso3_Metros_' + listMetros[valueSliderMetros]
            });


        } else if (currentIndex === 3 && nextIndex === 2) {

            setBlobActivoPar(<Blob2 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            tooltip.classList.remove("d-none");

            anime({
                targets: tooltip,
                opacity: [0, 1],
                duration: 3000,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso3_Metros_' + listMetros[valueSliderMetros]
            });

        } else if (currentIndex === 3 && nextIndex === 4) {

            setBlobActivoImpar(<Blob3 />);
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");
            logo_mvc.setAttribute("style", "fill: white !important");
            tooltip.classList.remove("d-none");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueSuelo = document.querySelector('#mvc-pregunta-4').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso4_Suelo_' + valueSuelo
            });


        } else if (currentIndex === 4 && nextIndex === 5) {

            setBlobActivoPar(<Blob4 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            logo_mvc.setAttribute("style", "fill: #1E48BC !important");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valuePared = document.querySelector('#mvc-pregunta-6').value.normalize('NFD').toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso5_Paredes_' + valuePared
            });

        } else if (currentIndex === 4 && nextIndex === 3) {

            setBlobActivoPar(<Blob2 />);
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");
            logo_mvc.setAttribute("style", "fill: #1E48BC !important");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueSuelo = document.querySelector('#mvc-pregunta-4').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso4_Suelo_' + valueSuelo
            });

        } else if (currentIndex === 5 && nextIndex === 4) {

            setBlobActivoImpar(<Blob3 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            logo_mvc.setAttribute("style", "fill: white !important");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valuePared = document.querySelector('#mvc-pregunta-6').value.normalize('NFD').toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso5_Paredes_' + valuePared
            });

        } else if (currentIndex === 5 && nextIndex === 6) {

            setBlobActivoImpar(<Blob4 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueCocina = document.querySelector('#mvc-pregunta-7').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso6_Cocina_' + valueCocina
            });

        } else if (currentIndex === 6 && nextIndex === 5) {

            setBlobActivoImpar(<Blob4 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueCocina = document.querySelector('#mvc-pregunta-8').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso6_Cocina_' + valueCocina
            });

        } else if (currentIndex === 6 && nextIndex === 7) {

            setBlobActivoPar(<Blob5 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueDetalles = document.querySelector('#mvc-pregunta-8').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso7_Detalles_' + valueDetalles
            });

        } else if (currentIndex === 7 && nextIndex === 6) {

            setBlobActivoImpar(<Blob4 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueDetalles = document.querySelector('#mvc-pregunta-8').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso7_Detalles_' + valueDetalles
            });

        } else if (currentIndex === 7 && nextIndex === 8) {

            setBlobActivoPar(<Blob5 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueAseo = document.querySelector('#mvc-pregunta-9').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso8_Aseo_' + valueAseo
            });

        } else if (currentIndex === 8 && nextIndex === 7) {

            setBlobActivoPar(<Blob5 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueAseo = document.querySelector('#mvc-pregunta-9').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso8_Aseo_' + valueAseo
            });

        } else if (currentIndex === 8 && nextIndex === 9) {

            setBlobActivoImpar(<Blob6 />);
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueBide = document.querySelector('#mvc-pregunta-10').value;
            if (valueBide === 'Me quedo con el bidé, es importante para mí') {
                window.dataLayer.push({
                    'event': 'evento',
                    'eventcategory': 'Formulario',
                    'eventaction': 'La casa que eres',
                    'eventlabel': 'Paso9_Bide_si'
                });

            } else {
                window.dataLayer.push({
                    'event': 'evento',
                    'eventcategory': 'Formulario',
                    'eventaction': 'La casa que eres',
                    'eventlabel': 'Paso9_Bide_no'
                });
            }

        } else if (currentIndex === 9 && nextIndex === 8) {

            setBlobActivoPar(<Blob5 />);
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueBide = document.querySelector('#mvc-pregunta-10').value;
            if (valueBide === 'Me quedo con el bidé, es importante para mí') {
                window.dataLayer.push({
                    'event': 'evento',
                    'eventcategory': 'Formulario',
                    'eventaction': 'La casa que eres',
                    'eventlabel': 'Paso9_Bide_si'
                });

            } else {
                window.dataLayer.push({
                    'event': 'evento',
                    'eventcategory': 'Formulario',
                    'eventaction': 'La casa que eres',
                    'eventlabel': 'Paso9_Bide_no'
                });
            }

        } else if (currentIndex === 9 && nextIndex === 10) {

            setBlobActivoPar(<Blob7 />);
            // arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            // textNext.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valuePersonalizacion = document.querySelector('#mvc-pregunta-11').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso10_Personalizacion_' + valuePersonalizacion
            });

        } else if (currentIndex === 10 && nextIndex === 9) {

            setBlobActivoImpar(<Blob6 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valuePersonalizacion = document.querySelector('#mvc-pregunta-11').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso10_Personalizacion_' + valuePersonalizacion
            });

        } else if (currentIndex === 10 && nextIndex === 11) {

            setBlobActivoPar(<Blob7 />);
            // arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            // textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso11_Prioridad_' + resultCardOrder.replace(/,/g, "-").toLowerCase()
            });

        } else if (currentIndex === 11 && nextIndex === 10) {

            setBlobActivoImpar(<Blob6 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso11_Prioridad_' + resultCardOrder.replace(/,/g, "-").toLowerCase()
            });

        } else if (currentIndex === 11 && nextIndex === 12) {

            setBlobActivoImpar(<Blob8 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueGaraje = document.querySelector('#mvc-pregunta-13').value.toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso12_Garaje_' + valueGaraje
            });

        } else if (currentIndex === 12 && nextIndex === 11) {

            setBlobActivoPar(<Blob7 />);
            // arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            // textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueGaraje = document.querySelector('#mvc-pregunta-13').value.toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso12_Garaje_' + valueGaraje
            });

        } else if (currentIndex === 12 && nextIndex === 13) {

            setBlobActivoImpar(<Blob8 />);
            arrowNextWhite.classList.replace("icono-arrow-next-white", "icono-arrow-next-blue");
            textNext.setAttribute("style", "color: #1E48BC");
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueExtras = document.querySelector('#mvc-pregunta-14').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso13_Extras_' + valueExtras
            });

        } else if (currentIndex === 13 && nextIndex === 12) {

            setBlobActivoPar(<Blob8 />);
            arrowNextBlue.classList.replace("icono-arrow-next-blue", "icono-arrow-next-white");
            textNext.setAttribute("style", "color: white");
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            const valueExtras = document.querySelector('#mvc-pregunta-15').value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso13_Extras_' + valueExtras
            });

        } else if (currentIndex === 13 && nextIndex === 14) {

            setBlobActivoPar(<Blob9 />);
            arrowPrevWhite.classList.replace("icono-arrow-prev-white", "icono-arrow-prev-blue");
            textPrev.setAttribute("style", "color: #1E48BC");

            anime({
                targets: tooltipCuota,
                opacity: [0, 1],
                duration: 1000,
                easing: 'linear',
            });

            reportWindowSize();

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso14_Espacios-comunes_' + resultSelectCard.toLowerCase()
            });

        } else if (currentIndex === 14 && nextIndex === 13) {

            setBlobActivoImpar(<Blob8 />);
            arrowPrevBlue.classList.replace("icono-arrow-prev-blue", "icono-arrow-prev-white");
            textPrev.setAttribute("style", "color: white");

            tooltipCuota.classList.add("d-none");

            anime({
                targets: tooltipCuota,
                opacity: [1, 0],
                duration: 4000,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            //convertir el string sin espacios y sin tildes separado por guiones
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso14_Espacios-comunes_' + resultSelectCard.toLowerCase()
            });

        } else if (currentIndex === 14 && nextIndex === 15) {

            setBlobActivoPar(<Blob9 />);

            tooltipCuota.classList.add("d-none");

            anime({
                targets: tooltipCuota,
                opacity: [1, 0],
                duration: 1000,
                easing: 'linear'
            });

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso15_Cuota-mensual_' + listCuota[valueSliderCuota]
            });


        } else if (currentIndex === 15 && nextIndex === 14) {

            setBlobActivoImpar(<Blob9 />);

            tooltipCuota.classList.remove("d-none");

            anime({
                targets: tooltipCuota,
                opacity: [0, 1],
                duration: 4000,
                easing: 'linear'
            });

            // quitamos el overflow hidden en el formulario para dispositivos móviles
            reportWindowSize();

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso15_Cuota-mensual_' + listCuota[valueSliderCuota]
            });

        } else if (currentIndex === 15 && nextIndex === 16) {

            setBlobActivoImpar(<Blob10 />);

            // quitamos el overflow hidden en el formulario para dispositivos móviles
            reportWindowSize();

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso16_Comentarios'
            });

        } else if (currentIndex === 16 && nextIndex === 15) {

            setBlobActivoPar(<Blob9 />);

            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'evento',
                'eventcategory': 'Formulario',
                'eventaction': 'La casa que eres',
                'eventlabel': 'Paso16_Comentarios'
            });

        } else if (currentIndex === 16 && nextIndex === 17) {

        }

    }

    //---------------------------------------//

    /* CONFIGURACIÓN DE RESPONSIVE DEL CAROUSEL EN LAS CARDS (5 CARDS) */
    const responsiveCincoCards = {
        desktop: {
            breakpoint: { max: 4000, min: 992 },
            items: 5,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 991.98, min: 576 },
            items: 3,
            slidesToSlide: 1,
            partialVisibilityGutter: 30,
        },
        mobile: {
            breakpoint: { max: 575.98, min: 0 },
            items: 2,
            partialVisibilityGutter: 20,
        }
    };

    /* CONFIGURACIÓN DE RESPONSIVE DEL CAROUSEL EN LAS CARDS (4 CARDS) */
    const responsiveCuatroCards = {
        desktop: {
            breakpoint: { max: 4000, min: 992 },
            items: 4,
            slidesToSlide: 4, // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 991.98, min: 768 },
            items: 3,
            slidesToSlide: 2, // optional, default to 1.
        },
        tabletMedium: {
            breakpoint: { max: 767.98, min: 576 },
            items: 2,
            slidesToSlide: 1, // optional, default to 1.
            partialVisibilityGutter: 40,
        },
        tabletSmall: {
            breakpoint: { max: 575.98, min: 320 },
            items: 1,
            slidesToSlide: 1, // optional, default to 1.
            partialVisibilityGutter: 100,
        },
        mobile: {
            breakpoint: { max: 319.98, min: 0 },
            items: 1,
            slidesToSlide: 1, // optional, default to 1.
            partialVisibilityGutter: 40,
        }
    };

    /* CONFIGURACIÓN DE RESPONSIVE DEL CAROUSEL EN LAS CARDS (3 CARDS) */
    const responsiveTresCards = {
        desktop: {
            breakpoint: { max: 4000, min: 992 },
            items: 3,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 991.98, min: 576 },
            items: 2,
            slidesToSlide: 1,
            partialVisibilityGutter: 30,
        },
        mobile: {
            breakpoint: { max: 575.98, min: 0 },
            items: 1,
            slidesToSlide: 1, // optional, default to 1.
            partialVisibilityGutter: 100,
        }
    };

    /* CONFIGURACIÓN DE RESPONSIVE DEL CAROUSEL EN LAS CARDS (2 CARDS) */
    const responsiveDosCards = {
        desktop: {
            breakpoint: { max: 3000, min: 768 },
            items: 2,
            slidesToSlide: 1, // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 767.98, min: 0 },
            items: 1,
            slidesToSlide: 1, // optional, default to 1.
            partialVisibilityGutter: 30
        }
    };

    //---------------------------------------//

    /* ARRAYS DE LAS CARDS POR TIPO */

    //array con los tipos de suelo
    const tipoSuelo = {
        "solado_ceramico_calido": "Solado cerámico (tonos cálidos)",
        "solado_ceramico_frio": "Solado cerámico (tonos grises)",
        "solado_ceramico_madera": "Solado cerámico madera",
        "tarima_gris": "Tarima gris",
        "tarima_calida": "Tarima cálida"
    }


    //array con los tipos de suelo
    const identificato = {
        "residencia 1": "Solado cerámico (tonos cálidos)",
        "solado_ceramico_frio": "Solado cerámico (tonos grises)",
        "solado_ceramico_madera": "Solado cerámico madera",
        "tarima_gris": "Tarima gris",
        "tarima_calida": "Tarima cálida"
    }

    //array con los tipos de pared
    const tipoPared = {
        "pared_beige": "Beige claro",
        "pared_blanca": "Blanco roto",
        "pared_gris": "Gris"
    }

    //array con los tipos de cocina
    const tipoCocina = {
        "cocina_abierta": "Abierta",
        "cocina_semiabierta": "Semiabierta (con puerta corredera al salón comedor)",
        "cocina_cerrada": "Cerrada"
    }

    //array con los tipos de cocina
    const tipoCocina1 = {
        "cocina_abierta": "Abierta",
        "cocina_semiabierta": "Semiabierta (con puerta corredera al salón comedor)",
        "cocina_cerrada": "Cerrada"
    }

    //array con los tipos de los acabados
    const tipoAcabados = {
        "suelos_vivienda": "Los suelos de la vivienda",
        "suelos_alicatado_bano": "Los suelos y alicatados del baño",
        "acabados_puertas": "Los acabados de las puertas",
        "colores_cocina": "Los colores de la cocina",
        "color_paredes": "El color de las paredes"
    }


    //array con los tipos de los acabados
    const podrias = {
        "1ª residencia": "975310000",
        "1ª residencia reposición": "975310004",
        "2ª residencia": "975310001",
        "Inversión": "975310002",
        "Otros": "975310003"
    }

    //array con los tipos de baño secundario
    const tipoBanosecundario = {
        "banera": "Bañera",
        "ducha": "Ducha"
    }

    //array con los tipos de baño principal (bidet)
    const tipoBanobidet = {
        "con_bide": "Me quedo con el bidé, es importante para mí",
        "sin_bide": "Prescindiría del bidé"
    }

    //array con los tipos de personalización
    const tipoEquipamiento = {
        "equipamiento_cocina": "Elegir entre cocina semi-abierta, abierta o cerrada",
        "equipamiento_salon_4dormitorios": "Escoger entre 4º dormitorio a salón o Viviendas de 4 dormitorios",
        "equipamiento_unirDormitorios": "Unir dormitorios"
    }

    //array con las cards de equipamiento para ordenar por preferencia
    const tipoEquipamientoReorder = [
        {
            name: "equipamiento_cocina",
            content: "Elegir entre cocina semi-abierta, abierta o cerrada",
            value: "cocina"
        },
        {
            name: "equipamiento_salon_4dormitorios",
            content: "Escoger entre 4º dormitorio a salón o Viviendas de 4 dormitorios",
            value: "salon"
        },
        {
            name: "equipamiento_unirDormitorios",
            content: "Unir dormitorios",
            value: "dormitorio"
        }
    ]
    //variable donde se guardan las cards de equipamiento
    const [listCards, setListCards] = useState(tipoEquipamientoReorder);

    //array con el número de plazas de garaje
    const tipoGaraje = {
        "una_plaza": "Una",
        "dos_plazas": "Dos"
    }

    //array con las cards de innovación
    const tipoInnovacion = {
        "domotica": "Domótica (automatización inteligente de la vivienda)",
        "luz": "Poner luminarias en baños, cocina y pasillos",
        "cargador_electrico": "Cargador eléctrico en plaza de garaje",
        "persianas": "Motorización de persianas"
    }

    //array con las cards de espacios comunes
    const tipoEspacioComun = {
        "zona_infantil": "Zonas infantiles",
        "gimnasio": "Gimnasio",
        "piscina": "Piscina",
        "pista_padel": "Pista de padel",
        "zonas_deportivas": "Otras zonas deportivas",
        "parking_bicis": "Parking para bicicletas",
        "sala_multiusos": "Sala multiusos",
        "vigilancia": "Control y vigilancia de accesos"
    }

    //---------------------------------------//

    /* FUNCIÓN GENERAL DE LA SELECCIÓN DE CARDS Y GUARDAR EL VALOR EN REDUX DE ALGUNAS PREGUNTAS*/

    //función para coger de redux las preguntas en las que se selecciona solo 1 card
    function selectedCard(ev) {
        //variable que selecciona la card a la que haces click
        const currentCard = ev.currentTarget;
        //accedemos al padre de las cards para luego poder acceder al input
        const parentCurrentCard = currentCard.closest('#parent');
        //obtenemos el input hidden de la pregunta
        const inputCard = parentCurrentCard.querySelector('.inputCard');
        //variable donde se guardan todas las cards en un listado
        const listCards = document.querySelectorAll('.card, .cardsDos, .cardsTres, .cardsCuatro, .cardsOcho');

        //bucle para que seleccione la Card activa donde se hace click,
        // y para deshabilitar el botón siguiente si no se selecciona una card
        for (let i = 0; i < listCards.length; i++) {
            const selectedCard = listCards[i].classList.contains("selectedCard"); //valor booleano, por defecto FALSE
            if (!selectedCard) {
                currentCard.classList.add("selectedCard");
                listCards[i].classList.remove("selectedCard");
                const buttonNext = document.querySelector(".awssld__next");
                buttonNext.classList.remove("disabledNext");
            } else {
                listCards[i].classList.remove("selectedCard");
                currentCard.classList.add("selectedCard");
            }
        }
        // comprobamos la posición de la card por si está en una zona no visible que se mueva
        moveCardSelected(currentCard);

        //obtenemos el atributo del div que contiene la card
        const valueCard = currentCard.getAttribute('data-atributo');
        //seteamos el valor del input y le asignamos el valor de la card seleccionada
        inputCard.setAttribute("value", valueCard);

    }

    // en esta variable iremos añadiendo el valor del carousel en cada uno de los sliders
    // esto nos permite recuperarla y acceder a sus métodos y propiedades
    let carouselRef = useRef();

    /**
     * Función moveCardSelected.
     * Esta función mueve un step el carousel al hacer click si la cards está fuera de la zona visible
     *
     * @param currentCard la card que ha sido seleccionada
     */
    function moveCardSelected(currentCard) {

        const numeroCardSelected = currentCard.parentElement.getAttribute('data-index');
        const slidesToShow = carouselRef.state.slidesToShow;
        const totalItems = carouselRef.state.totalItems;

        // Comprobamos si el carrousel tiene sliders
        if (slidesToShow < totalItems) {

            // Añadimos una posición al slider porque comienza en cero y no podemos hacer cuentas
            const cardSelected = parseInt(numeroCardSelected) + 1;
            let positionSlideCard;
            // Determinamos en qué slider tiene que estar la card seleccionada y restamos uno porque la función goToSlide
            // toma el primer slider como 0
            positionSlideCard = Math.ceil(cardSelected / slidesToShow) - 1;

            if (totalItems === 5) {

                positionSlideCard += 1;
            }

            // vamos al slider donde está la card seleccionada
            carouselRef.goToSlide(positionSlideCard);
        }

    }

    function moveCardsSelectedPrev(numeroCardSelected) {

        if (numeroCardSelected !== undefined) {
            // para que las cards se posicionen visibles siempre para el usuario
            const slidesToShow = carouselRef.state.slidesToShow;
            const totalItems = carouselRef.state.totalItems;

            // Comprobamos si el carrousel tiene sliders
            if (slidesToShow < totalItems) {

                let positionSlideCard;
                // Añadimos una posición al slider porque comienza en cero y no podemos hacer cuentas
                const cardSelected = parseInt(numeroCardSelected) + 1;
                // Determinamos en qué slider tiene que estar la card seleccionada y restamos uno porque la función goToSlide
                // toma el primer slider como 0
                positionSlideCard = Math.ceil(cardSelected / slidesToShow) - 1;

                if (totalItems === 5) {

                    positionSlideCard += 1;
                }
                // vamos al slider donde está la card seleccionada
                carouselRef.goToSlide(positionSlideCard);

            }
        }

    }

    //función para coger de redux la pregunta seleccionar 3 cards
    function selectTresCards(ev) {
        //variable que selecciona la card a la que haces click
        const currentCard = ev.currentTarget;
        //accedemos al padre de las cards para luego poder acceder al input
        const parentCurrentCard = document.querySelector('#parentSelect');
        //variable donde se guardan todas las cards en un listado
        const listCards = document.querySelectorAll('.card, .cardsOcho');
        //listado de cards seleccionadas
        const listSelectCards = parentCurrentCard.querySelectorAll(".card.selectedCard");
        //variable donde guardamos los datos de las 3 cards seleccionadas
        const valueSelectedCards = new Array();
        //variable del boton siguiente
        const buttonNext = document.querySelector(".awssld__next");

        //verificamos que las cards si están seleccionadas puedan deseleccionarse
        if (currentCard.classList.contains("selectedCard")) {
            currentCard.classList.remove("selectedCard");
            //condición para que si se deseleccionan las cards se deshabilita el botón de siguiente
            if (listSelectCards.length <= 3) {
                buttonNext.classList.add("disabledNext");
            }
            return;
        }

        //condición para recoger el valor de las 3 cards cuando estén seleccionadas
        if (listSelectCards.length < 2) {
            currentCard.classList.add("selectedCard");

        } else if (listSelectCards.length === 2) {
            currentCard.classList.add("selectedCard");

            for (let i = 0; i < listSelectCards.length; i++) {
                const valueCardsSelect = listSelectCards[i].getAttribute("data-atributo");
                valueSelectedCards.push(valueCardsSelect);
            }
            //se habilita el botón de siguiente en el caso de que haya 3 cards seleccionadas
            buttonNext.classList.remove("disabledNext");
            //se pushea el valor de última card seleccionada en un array
            valueSelectedCards.push(currentCard.getAttribute("data-atributo"));

        } else if (listSelectCards.length === 3) {
            return;
        }
        //obtenemos el input hidden de la pregunta
        const inputCardsSelect = parentCurrentCard.querySelector('.inputCard');
        //seteamos el valor del input y le asignamos el valor de la card seleccionada
        inputCardsSelect.setAttribute("value", valueSelectedCards.toString());
        setResultSelectCard(valueSelectedCards.toString());
    }

    //variable para mostrar el estado de error en el textarea
    const [error, setError] = useState(false);

    //función para coger de redux la pregunta textarea y validación
    function handleChangeInput(ev) {
        const name = ev.target.name;
        const value = ev.target.value;

        if (value.length > 500) {
            setError(true);
            return;
        } else {
            setError(false);
            dispatch(setFormSlice({
                form: {
                    ...form,
                    [name]: value,
                }
            }));
        }
    }

    //función para arastrar y reordenar las cards
    function onDragEnd(result) {
        if (!result.destination) return;

        const items = Array.from(listCards);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setListCards(items);

        //se llama a la función para salvar los datos de las card
        saveCardsOrder(items);
    }


    //función que recoge los valores de las cards ordenables y las guarda en un array como string
    function saveCardsOrder(items) {

        //creamos una variable string vacía para meter después las respuestas por el orden establecido
        const resultOrder = new Array();
        //accedemos al padre de las cards para luego poder acceder al input
        const parentSelectCard = document.querySelector('#parentCardsOrder');
        //obtenemos el input hidden de la pregunta
        const inputCardsOrder = parentSelectCard.querySelector('.inputCard');

        //se recorre con un bucle las cards para obtener el valor y el orden en el que se recogen
        for (let i = 0; i < items.length; i++) {
            const valueCard = items[i].value;
            resultOrder.push(valueCard);
        }
        //seteamos el valor del input y le asignamos el valor de las cards por su orden
        inputCardsOrder.setAttribute("value", resultOrder.toString());
        setResultCardOrder(resultOrder.toString());
    }

    //---------------------------------------//

    /* LISTADO DE PREGUNTAS Y FUNCIÓN DE MAPEO */

    const preguntas = [

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title
                        title="Tu casa, tu futuro hogar: ¿Podrías indicarnos el motivo de compra con el que te sientes más identificado?" />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsCinco" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveCincoCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            infinite={false}
                            containerClass="container-CardsCinco px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(podrias).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[1] + ".png"} alt={keyName[1]}
                                    textCard={keyName[0]}
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-1" type="hidden" className="inputCard"
                            name="form.motivo" value="" />
                    </div>
                </div>
            </div>
        </div>,


        <div className="form__content__step container">

            <div className="row align-items-center subtitle-slider">
                <div className="form__content__step__groupTitles offset-2 col-10">
                    <Title title="¿Cuántos años tienes?" />
                    <Subtitle subtitle="No se lo diremos a nadie, prometido." />
                </div>
            </div>

            <div className="form__content__step__rangoEdad row">
                <div className="offset-2 col-10 col-md-8 col-lg-6">
                    <ul className="form__content__step__rangoEdad__age-list">
                        <li>{nameAges[countAge]}</li>
                        <input id="mvc-pregunta-2" type="hidden" name="form.rangoedad" value={valueAges[countAge]} />
                    </ul>
                </div>

                <div className="form__content__step__rangoEdad__buttons col-2 d-none d-md-inline-flex">
                    <ButtonArrow classname="form__content__step__rangoEdad__buttons__button-arrow-up"
                        function={incrementAgeList}
                        src={url + "/icons/arrowUp.png"}
                        alt="arrow_up"
                    />
                    <ButtonArrow classname="form__content__step__rangoEdad__buttons__button-arrow-down"
                        function={decrementAgeList}
                        src={url + "/icons/arrowDown.png"}
                        alt="arrow_down"
                    />
                </div>

                <div
                    className="form__content__step__rangoEdad__buttons offset-2 col-10 d-inline-flex d-md-none">
                    <div className="row">
                        <div className="offset-2 col-4">
                            <ButtonArrow
                                classname="form__content__step__rangoEdad__buttons__button-arrow-up btn-mobile-right"
                                function={decrementAgeList}
                                src={url + "/icons/arrowUp.png"}
                                alt="arrow_up"
                            />
                        </div>
                        <div className="col-4">
                            <ButtonArrow
                                classname="form__content__step__rangoEdad__buttons__button-arrow-down btn-mobile-left"
                                function={incrementAgeList}
                                src={url + "/icons/arrowDown.png"}
                                alt="arrow_down"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-8 form__content__step__groupTitles">
                    <Title title="Las habitaciones, esos pequeños reinos. ¿Cuántas te gustaría tener?" />
                </div>
            </div>

            <div className="row form__content__step__sliderDormitorios">
                <div className="col-12 col-md-4 form__content__step__sliderDormitorios__labelsSlider">
                    <ul className="form__content__step__sliderDormitorios__labelsSlider__range-labels">
                        <p className="form__content__step__sliderDormitorios__labelsSlider__range-labels__title m-0">{valueSlider}</p>
                        <p className="form__content__step__sliderDormitorios__labelsSlider__range-labels__cuota ml-2 ml-lg-4 mb-0">{numhabitacion}</p>
                        <input id="mvc-pregunta-3" type="hidden" name="form.numerohabitaciones"
                            value={valuesNumHab[valueSlider - 1]} />
                    </ul>
                    <Slider
                        className="slider-dormitorios mt-3 mt-lg-6"
                        value={valueSlider}
                        min={1}
                        max={4}
                        step={1}
                        onChange={changeNumHab}
                        dots={false}
                    />

                </div>
                <div className="form__content__step__imgCamas col-12 col-md-8 pl-4 pt-4 pt-md-5 pt-xl-0">
                    {showBeds()}
                    <img className="form__content__step__imgCamas__cama leftBed mb-2 mb-md-4 mx-2 mx-md-4"
                        src={url + "/images/bed.png"}
                        alt="cama" />
                    <img className="mvc-opacity-cero form__content__step__imgCamas__cama mb-2 mb-md-4 mx-2 mx-md-4"
                        src={url + "/images/bed.png"}
                        alt="cama" />
                    <img
                        className="mvc-opacity-cero form__content__step__imgCamas__cama leftBed mb-2 mb-md-4 mx-2 mx-md-4"
                        src={url + "/images/bed.png"}
                        alt="cama" />
                    <img className="mvc-opacity-cero form__content__step__imgCamas__cama mb-2 mb-md-4 mx-2 mx-md-4"
                        src={url + "/images/bed.png"}
                        alt="cama" />
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-lg-8 form__content__step__groupTitles">
                    <Title title="¿Cuántos metros cuadrados quieres para vivir?" />
                </div>
            </div>
            <div className="row align-items-end metros-row">
                <div className="col-12 form__content__step__rangeSliderMetros">
                    <Slider
                        className="slider-metros"
                        value={valueSliderMetros}
                        defaultValue={1}
                        startPoint={1}
                        min={0}
                        max={5}
                        step={1}
                        onChange={changeMetros}
                        dots={true}
                        handle={handle}
                    />
                    <input type="hidden" id="mvc-pregunta-4" name="form.rangom2"
                        value={listValueMetros[valueSliderMetros]} />
                </div>
            </div>
        </div>,


        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Las paredes dan forma a tu casa. ¿De qué color te gustaría que fueran?" />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsTres" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveTresCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            containerClass="container-CardsTres px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoPared).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsTres"
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-5" type="hidden" className="inputCard" name="form.colorpared"
                            value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Para muchos, el alma del hogar es la cocina. ¿Cómo quieres que sea?" />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsTres" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveTresCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            containerClass="container-CardsTres px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoCocina).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsTres"
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-6" type="hidden" className="inputCard" name="form.tipococina"
                            value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title
                        title="Tu hogar es parte de ti. Si pudieras personalizar sus detalles y acabados, ¿por dónde empezarías?" />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsCinco" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveCincoCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            infinite={false}
                            containerClass="container-CardsCinco px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoAcabados).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]}
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-7" type="hidden" className="inputCard"
                            name="form.personalizacionacabados" value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Supongamos que el baño principal de tu casa está equipado con una ducha.
                        ¿Qué preferirías para el secundario?"/>
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsDos" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveDosCards}
                            swipeable={true}
                            draggable={false}
                            additionalTransfrom={0}
                            focusOnSelect={false}
                            arrows={false}
                            containerClass="container-CardsDos-bano px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoBanosecundario).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsDos-bano"
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-8" type="hidden" className="inputCard" name="form.banosecundario"
                            value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="¿Y si te dieran la posibilidad de prescindir del bidé en el baño
                    principal?"/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form__content__step__cardsDos" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveDosCards}
                            swipeable={true}
                            draggable={false}
                            additionalTransfrom={0}
                            focusOnSelect={false}
                            arrows={false}
                            containerClass="container-CardsDos container-CardsDos-bidet px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoBanobidet).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsDos-bidet"
                                />
                            ))}
                        </Carousel>

                        <input id="mvc-pregunta-9" type="hidden" className="inputCard" name="form.bidet"
                            value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 form__content__step__groupTitles">
                    <Title title="¿Si solo pudieras elegir una opción de personalización, cuál sería?" />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12">
                    <div className="form__content__step__cardsTres" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveTresCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            containerClass="container-CardsTres px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoEquipamiento).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsTres"
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-10" type="hidden" name="form.opcion_personalizacion" value=""
                            className="inputCard" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider-drops">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Imaginemos que estas opciones tuvieran un coste extra. ¿Cuál sería tu prioridad?" />
                    <Subtitle
                        subtitle="Arrastra y ordena las opciones según tus preferencias. 1 es la prioridad más alta y 3 la más baja." />
                </div>
            </div>
            <div className="row">
                <div className="col-12 form__content__step__cardsTres container-dragdrop" id="parentCardsOrder">
                    <input id="mvc-pregunta-11" type="hidden" value="" name="form.opcionpersonalizacion_coste"
                        className="inputCard" />
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="listCards" direction="horizontal">
                            {(provided) => (
                                <div
                                    className="listCards"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {listCards.map(({ name, content, value }, index) => {
                                        return (
                                            <Draggable key={name} draggableId={name} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className="listCards-cards">
                                                        <Card attribute={content}
                                                            function={saveCardsOrder}
                                                            keyID={name}
                                                            src={url + "/images/" + name + ".png"}
                                                            alt={name}
                                                            dataValue={value}
                                                            textCard={content}
                                                            className="no-carousel"
                                                        />
                                                        <div className="listCards-numbers">
                                                            <p>{index + 1}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Disponer de plaza de garaje en tu propia casa es un lujo, pero  no debería serlo.
                        ¿Cuántas plazas de garaje te gustaría tener?"/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form__content__step__cardsDos" id="parent">
                        <Carousel
                            partialVisible
                            ref={el => {
                                carouselRef = el;
                            }}
                            responsive={responsiveDosCards}
                            swipeable={true}
                            additionalTransfrom={0}
                            draggable={false}
                            arrows={false}
                            focusOnSelect={false}
                            containerClass="container-CardsDos-coches px-2 pb-2"
                            itemClass="pr-3 pr-lg-5"
                        >
                            {Object.entries(tipoGaraje).map((keyName) => (
                                <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsDos"
                                />
                            ))}
                        </Carousel>
                        <input id="mvc-pregunta-12" type="hidden" className="inputCard" name="form.garaje"
                            value="" />
                    </div>
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title title="Hagamos de tu hogar el mejor lugar para vivir. Teniendo en cuenta
                        que las siguientes opciones suponen un precio adicional adecuado, ¿con cuál te quedarías?"/>
                </div>
            </div>
            <div className="row pt-3 pt-md-0">
                <div className="col-12 form__content__step__cardsCuatro" id="parent">
                    <Carousel
                        partialVisible
                        ref={el => {
                            carouselRef = el;
                        }}
                        responsive={responsiveCuatroCards}
                        swipeable={true}
                        additionalTransfrom={0}
                        draggable={false}
                        focusOnSelect={false}
                        arrows={false}
                        containerClass="container-CardsCuatro px-2 pb-2"
                    >
                        {Object.entries(tipoInnovacion).map((keyName) => (
                            <Card attribute={keyName[1]} function={selectedCard} keyID={keyName[0]}
                                src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                textCard={keyName[1]} className="container-CardsCuatro pr-3 pr-lg-5"
                            />
                        ))}
                    </Carousel>
                    <input id="mvc-pregunta-13" type="hidden" className="inputCard" name="form.opcion_innovacion"
                        value="" />
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title
                        title="Lo que rodea tu casa también es parte de ella, y tiene la capacidad de mejorar tu calidad de vida." />
                    <Title title="Cuéntanos qué 3 opciones de espacios comunes serían para ti las más importantes." />
                </div>
            </div>
            <div className="row align-items-end mx-lg-4 mr-2">
                <div className="col-12 col-xl-10 form__content__step__cardsOcho" id="parentSelect">
                    <div className="row">
                        {Object.entries(tipoEspacioComun).map((keyName) => (
                            <div className="col-3">
                                <CardSelect attribute={keyName[1]} function={selectTresCards} keyID={keyName[0]}
                                    src={url + "/images/" + keyName[0] + ".png"} alt={keyName[1]}
                                    textCard={keyName[1]} className="container-CardsOcho"
                                />
                            </div>
                        ))}
                    </div>
                    <input id="mvc-pregunta-14" type="hidden" className="inputCard" name="form.top3"
                        value="" />
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 col-xl-10 form__content__step__groupTitles">
                    <Title
                        title="En este camino de conseguir la casa de tu sueños, ¿qué cuota mensual de hipoteca se podría asumir en tu unidad familiar?" />
                </div>
            </div>
            <div className="row align-items-center cuota-row mt-5 ml-md-5 ml-lg-0">
                <div className="col-12 col-md-10 form__content__step__rangeSliderCuota px-4 px-md-5 px-lg-7">
                    {mobile ?
                        <Slider
                            className="slider-cuota-vertical"
                            vertical
                            min={1}
                            max={6}
                            step={1}
                            dots={false}
                            value={valueSliderCuota}
                            onChange={changeCuota}
                            handle={handleCuotaVertical}
                        />
                        :
                        <Slider
                            className="slider-cuota"
                            value={valueSliderCuota}
                            min={1}
                            max={6}
                            step={1}
                            onChange={changeCuota}
                            dots={false}
                            handle={handleCuota}
                        />}
                    <div>
                    </div>
                    <input type="hidden" id="mvc-pregunta-15" name="form.rangohipoteca"
                        value={valuesCuota[valueSliderCuota - 1]} />
                </div>
            </div>
        </div>,

        <div className="form__content__step container">
            <div className="row align-items-center subtitle-slider">
                <div className="col-12 form__content__step__groupTitles-pregunta">
                    <Title title="¿Nos quieres contar algo más de la casa de tus sueños?" />
                    <div className="form__content__step__groupTitles-pregunta-subtitles pb-3 pt-0 pt-lg-3">
                        <Subtitle
                            subtitle="La idea de esta pregunta es seguir aprendiendo de ti, entender qué es lo que
                                quieres y en un futuro, construir La Casa que Eres."/>
                    </div>
                </div>
            </div>
            <div className="row align-items-start pregunta-row">
                <div className="col-12">
                    <div className="form__content__step__pregunta" id="parent">
                        <div className="form-group">
                            <textarea
                                rows="10" cols="100"
                                aria-describedby="prreguntaFeedback"
                                className="form-control"
                                placeholder="Escribe aquí tu pregunta. (Máx. 500 caracteres)"
                                name="comentarios"
                                id="pregunta"
                                onChange={handleChangeInput}
                                value={form.comentarios}
                            />
                            {error && (
                                <div id="prreguntaFeedback" className="invalid-feedback d-flex">
                                    Máximo 500 caracteres
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>,

        <FormUser />,

        <Submitted />

    ]
        ;

    //mapeo de preguntas para visualizarlas individualmente
    const lista_preguntas = preguntas.map((pregunta) =>
        <div className="">{pregunta}</div>);


    //---------------------------------------//

    return (
        <Div100vh>
            <div className="form">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="titulo-casa text-primary mb-0 mb-md-3 pt-0 pt-md-2 d-none">La Casa que Eres</h3>
                        </div>
                    </div>
                </div>
                <LayerBox active={active} />
                <div className="form__content">
                    <Contador count={count} />
                    <AwesomeSlider
                        organicArrows={false}
                        buttonContentRight={
                            <div className={"btn-awesome button-awesome-custom-next"}>
                                {"siguiente"}
                                <i id="next-awesome" className={"icono-arrow icono-arrow-next-white"} />
                            </div>

                        }
                        buttonContentLeft={
                            <div className={"btn-awesome button-awesome-custom-prev"}>
                                {"anterior"}
                                <i id="prev-awesome" className={"icono-arrow icono-arrow-prev-blue"} />
                            </div>

                        }
                        className="d-flex vw-100"
                        onTransitionEnd={index_slider}
                        onTransitionStart={transition_start_slider}
                        mobileTouch={false}
                    >
                        {lista_preguntas}
                    </AwesomeSlider>
                </div>

                <div className={"container-blob"}>
                    {blobActivoImpar}
                    {blobActivoPar}
                </div>
            </div>
        </Div100vh>
    );
}

export default Form;
